import React from 'react';
import { BlogPost } from './types';
import { useDateTimeFormatter } from '../../../features/src/i18n';
import Link from 'next/link';
import { ImageAspectBox16x9 } from '../ui';
import { ContentfulImage } from '@spotify-internal/frodor-modules';
import { Text, cssSpacing, cssColorValue } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { TrackVisibility } from '../../utils/Visibility/TrackVisibility';

const Card = styled(Link)`
  display: block;
  width: 100%;
  margin-bottom: ${cssSpacing('looser-4')};
  color: ${cssColorValue('textBase')};
  text-decoration: none;

  &:hover .title {
    text-decoration: underline;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${cssSpacing('base')};
  time {
    margin-bottom: ${cssSpacing('base')};
  }
  .description {
    margin-top: ${cssSpacing('looser')};
  }
`;

export const BlogPostPreview = ({ blogPost }: { blogPost: BlogPost }) => {
  const dateFormatter = useDateTimeFormatter();
  const releaseDateLocalized = dateFormatter.format(
    new Date(blogPost.releaseDate),
  );
  return (
    <TrackVisibility
      threshold={0.6}
      eventCategory="Frodor - blog post preview"
      eventLabel={blogPost.title}
    >
      <Card href={`/blog/${blogPost.urlSlug}`}>
        {blogPost.featuredAsset && (
          <ImageAspectBox16x9>
            <ContentfulImage
              asset={blogPost.featuredAsset}
              placeholder={false}
            />
          </ImageAspectBox16x9>
        )}
        <ContentWrapper>
          <Text as="time" variant="bodySmall" dateTime={blogPost.releaseDate}>
            {releaseDateLocalized}
          </Text>
          <Text className="title" variant="titleLarge">
            {blogPost.title}
          </Text>
          {blogPost.description && (
            <Text className="description" variant="bodyMedium">
              {blogPost.description}
            </Text>
          )}
        </ContentWrapper>
      </Card>
    </TrackVisibility>
  );
};
